var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "filed-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            id: "editForm",
            model: _vm.edit,
            elem: _vm.editElem,
            rules: _vm.editRule,
            "label-width": 80,
            submit: false,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "名称", prop: "name" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入名称",
                          maxlength: "50",
                        },
                        model: {
                          value: _vm.edit.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "name", $$v)
                          },
                          expression: "edit.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        "label-width": 45,
                        label: "别名",
                        prop: "alias",
                      },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入别名",
                          maxlength: "50",
                        },
                        model: {
                          value: _vm.edit.alias,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "alias", $$v)
                          },
                          expression: "edit.alias",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "8" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: { "label-width": 45, label: "编码", prop: "code" },
                    },
                    [
                      _c("Input", {
                        attrs: {
                          type: "text",
                          placeholder: "请输入编码",
                          maxlength: "50",
                          disabled: _vm.edit.id ? true : false,
                        },
                        model: {
                          value: _vm.edit.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "code", $$v)
                          },
                          expression: "edit.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "必填", prop: "isRequired" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { prop: "isRequired" },
                          model: {
                            value: _vm.edit.isRequired,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "isRequired", $$v)
                            },
                            expression: "edit.isRequired",
                          },
                        },
                        _vm._l(_vm.enums.isOrNot, function (item) {
                          return _c(
                            "Radio",
                            {
                              key: item.value,
                              staticStyle: { "font-size": "15px" },
                              attrs: { label: item.value },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "只读", prop: "isRead" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { prop: "isRead" },
                          model: {
                            value: _vm.edit.isRead,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "isRead", $$v)
                            },
                            expression: "edit.isRead",
                          },
                        },
                        _vm._l(_vm.enums.isOrNot, function (item) {
                          return _c(
                            "Radio",
                            {
                              key: item.value,
                              staticStyle: { "font-size": "15px" },
                              attrs: { label: item.value },
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "单位", prop: "unit" } },
                    [
                      _c("Input", {
                        attrs: { type: "text", placeholder: "请输入单位" },
                        model: {
                          value: _vm.edit.unit,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "unit", $$v)
                          },
                          expression: "edit.unit",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "默认值", prop: "defaultValue" } },
                    [
                      _c("Input", {
                        attrs: { type: "text", placeholder: "请输入默认值" },
                        model: {
                          value: _vm.edit.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "defaultValue", $$v)
                          },
                          expression: "edit.defaultValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "元素类型", prop: "elementType" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          on: { "on-change": _vm.changeElementType },
                          model: {
                            value: _vm.edit.elementType,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "elementType", $$v)
                            },
                            expression: "edit.elementType",
                          },
                        },
                        _vm._l(_vm.enums.elementTypes, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "占列数", prop: "columnNumber" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.edit.columnNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "columnNumber", $$v)
                            },
                            expression: "edit.columnNumber",
                          },
                        },
                        _vm._l(_vm.enums.columnNumbers, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _vm.edit.elementType === 12
                ? _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "默认日期", prop: "defaultToday" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.defaultToday,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "defaultToday", $$v)
                                },
                                expression: "edit.defaultToday",
                              },
                            },
                            _vm._l(_vm.enums.defaultDate, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.edit.elementType === 8 ||
              _vm.edit.elementType === 9 ||
              _vm.edit.elementType === 10 ||
              _vm.edit.elementType === 11
                ? _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "节点类型", prop: "type" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.edit.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "type", $$v)
                                },
                                expression: "edit.type",
                              },
                            },
                            _vm._l(_vm.enums.nodeTypes, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.edit.elementType === 1 ||
              _vm.edit.elementType === 2 ||
              _vm.edit.elementType === 3 ||
              _vm.edit.elementType === 15
                ? _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "值长度", prop: "valueLength" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "number",
                              placeholder: "请输入值长度",
                            },
                            model: {
                              value: _vm.edit.valueLength,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "valueLength", $$v)
                              },
                              expression: "edit.valueLength",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.edit.elementType === 3
                ? _c(
                    "Col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { label: "小数点位数", prop: "decimalLimit" },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "number",
                              placeholder: "请输入小数点位数",
                            },
                            model: {
                              value: _vm.edit.decimalLimit,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "decimalLimit", $$v)
                              },
                              expression: "edit.decimalLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "范围", prop: "range" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "11" } },
                            [
                              _c("Input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入开始范围",
                                },
                                model: {
                                  value: _vm.edit.startRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.edit, "startRange", $$v)
                                  },
                                  expression: "edit.startRange",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: "2" },
                            },
                            [_vm._v("~")]
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "11" } },
                            [
                              _c("Input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "请输入结束范围",
                                },
                                model: {
                                  value: _vm.edit.endRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.edit, "endRange", $$v)
                                  },
                                  expression: "edit.endRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "适用年龄", prop: "ageId" } },
                    [
                      _c(
                        "Row",
                        [
                          _c(
                            "Col",
                            { attrs: { span: "11" } },
                            [
                              _c(
                                "Select",
                                {
                                  model: {
                                    value: _vm.edit.minAgeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "minAgeId", $$v)
                                    },
                                    expression: "edit.minAgeId",
                                  },
                                },
                                _vm._l(_vm.applicableAgeList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.value,
                                      attrs: { value: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            {
                              staticStyle: { "text-align": "center" },
                              attrs: { span: "2" },
                            },
                            [_vm._v("~")]
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "11" } },
                            [
                              _c(
                                "Select",
                                {
                                  model: {
                                    value: _vm.edit.maxAgeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.edit, "maxAgeId", $$v)
                                    },
                                    expression: "edit.maxAgeId",
                                  },
                                },
                                _vm._l(_vm.applicableAgeList, function (item) {
                                  return _c(
                                    "Option",
                                    {
                                      key: item.value,
                                      attrs: { value: item.value },
                                    },
                                    [_vm._v(_vm._s(item.label))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "性别" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.edit.gender,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "gender", $$v)
                            },
                            expression: "edit.gender",
                          },
                        },
                        _vm._l(_vm.enums.genderList, function (item) {
                          return _c(
                            "Option",
                            { key: item.code, attrs: { value: item.code } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "互斥值" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: true },
                          model: {
                            value: _vm.edit.mutexId,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "mutexId", $$v)
                            },
                            expression: "edit.mutexId",
                          },
                        },
                        _vm._l(_vm.edit.options, function (item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "业务类型", prop: "businessType" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.edit.businessType,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "businessType", $$v)
                            },
                            expression: "edit.businessType",
                          },
                        },
                        _vm._l(_vm.businessTypeList, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.edit.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.edit, "status", $$v)
                            },
                            expression: "edit.status",
                          },
                        },
                        _vm._l(_vm.enums.status, function (item) {
                          return _c(
                            "Option",
                            { key: item.value, attrs: { value: item.value } },
                            [_vm._v(_vm._s(item.label))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入备注",
                          rows: 2,
                        },
                        model: {
                          value: _vm.edit.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.edit, "remark", $$v)
                          },
                          expression: "edit.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.optionShowTypesCtrl.indexOf(_vm.edit.elementType) > -1
            ? _c(
                "Row",
                [
                  _c("Col", { attrs: { span: "24" } }, [
                    _c(
                      "button",
                      {
                        staticClass: "ivu-btn ivu-btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.addChlidNode()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-plus" }),
                        _vm._v("添加子节点"),
                      ]
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _c(
            "Row",
            { staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "Col",
                { attrs: { span: "23" } },
                [
                  _vm.optionShowTypesCtrl.indexOf(_vm.edit.elementType) > -1
                    ? _c(
                        "FormItem",
                        { attrs: { label: "选项配置" } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.edit.options,
                                "row-key": "id",
                                border: "",
                                "tree-props": {
                                  children: "children",
                                  hasChildren: "hasChildren",
                                },
                                "header-cell-style": {
                                  background: "#f8f8f9",
                                  color: "#515a6e",
                                  "text-align": "left",
                                  height: "20px",
                                  "margin-top": "10px",
                                },
                                "cell-style": { "text-align": "left" },
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  fixed: "",
                                  prop: "name",
                                  label: "名称",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("el-input", {
                                            attrs: {
                                              placeholder: "请输入名称",
                                              maxlength: "50",
                                              size: "mini",
                                            },
                                            model: {
                                              value: row.name,
                                              callback: function ($$v) {
                                                _vm.$set(row, "name", $$v)
                                              },
                                              expression: "row.name",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1244373682
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "mutexArr", label: "互斥关系" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                placement: "top",
                                                sclearable: "",
                                                multiple: "",
                                                transfer: "",
                                              },
                                              on: {
                                                change: (val) => {
                                                  row.mutexArr = val
                                                },
                                              },
                                              model: {
                                                value: row.mutexArr,
                                                callback: function ($$v) {
                                                  _vm.$set(row, "mutexArr", $$v)
                                                },
                                                expression: "row.mutexArr",
                                              },
                                            },
                                            _vm._l(
                                              _vm.edit.options,
                                              function (rowItem) {
                                                return rowItem.name
                                                  ? _c(
                                                      "Option",
                                                      {
                                                        key: rowItem.id,
                                                        attrs: {
                                                          value: rowItem.id,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(rowItem.name)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  455853648
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "isDefault",
                                  label: "默认选中",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "Select",
                                            {
                                              attrs: {
                                                placement: "top",
                                                clearable: "",
                                                transfer: "",
                                              },
                                              model: {
                                                value: row.isDefault,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    row,
                                                    "isDefault",
                                                    $$v
                                                  )
                                                },
                                                expression: "row.isDefault",
                                              },
                                            },
                                            _vm._l(
                                              _vm.enums.isOrNot,
                                              function (rowItem) {
                                                return _c(
                                                  "Option",
                                                  {
                                                    key: rowItem.value,
                                                    attrs: {
                                                      value: rowItem.value,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(rowItem.label)
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  534919698
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "isShow",
                                  label: "展示",
                                  width: "100",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c("el-checkbox", {
                                            attrs: {
                                              label: "",
                                              "true-label": 1,
                                              "false-label": 2,
                                            },
                                            model: {
                                              value: row.isShow,
                                              callback: function ($$v) {
                                                _vm.$set(row, "isShow", $$v)
                                              },
                                              expression: "row.isShow",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2732327731
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: { fixed: "right", label: "操作" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ row }) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteNode(row.id)
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2444216609
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }